import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Col, Row } from 'reactstrap';

import BusinessApi from 'apis/Business';
import BusinessBasicInfo from 'components/businessDetail/businessBasicInfo';
import ContactInfo from 'components/businessDetail/primaryContact/contactInfo';
import BusinessLocationInfo from 'components/businessDetail/businessLocation/locationInfo';
import BusinessPlanInfo from 'components/businessDetail/businessPlan/planInfo';
import Loading from 'utils/Loading';
import 'assets/scss/business-information.css';
import PlansApi from '../apis/Plans';

class BusinessDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businessDetail: {
        categories: [],
        contact: {},
        plan_subscription: {},
        billing_addresses: [],
      },
      plans: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchPlans();
  }

  fetchPlans = () => {
    this.setState({ isLoading: true });
    PlansApi.getAll()
      .then(({ data }) => {
        this.setState({ plans: data }, this.fetchBusinessDetail);
      })
      .catch();
  };

  fetchBusinessDetail = () => {
    const {
      match: { params },
    } = this.props;
    this.setState({ isLoading: true });
    const { id } = params;
    BusinessApi.getDetails(id)
      .then(({ data }) => {
        this.setState({ businessDetail: data });
      })
      .catch(e => console.log(e))
      .then(() => this.setState({ isLoading: false }));
  };

  render() {
    const { businessDetail, isLoading, plans } = this.state;
    const {
      name,
      website,
      description,
      categories,
      contact,
      address_line_1: addressLine1,
      address_line_2: addressLine2,
      city,
      state,
      zip,
      primary_number: primaryNumber,
      location_code: locationCode,
      plan_subscription: planSubscription,
      billing_addresses,
    } = businessDetail;
    const locationData = {
      addressLine1,
      addressLine2,
      city,
      state,
      zip,
      primaryNumber,
      locationCode,
    };

    if (isLoading) {
      return <Loading />;
    }
    return (
      <Row>
        <Col md={4}>
          <BusinessBasicInfo
            name={name}
            website={website}
            description={description}
            categories={categories}
            fetchBusinessDetail={this.fetchBusinessDetail}
          />
        </Col>
        <Col md={8}>
          <Row>
            <Col>
              <ContactInfo
                contact={contact}
                fetchBusinessDetail={this.fetchBusinessDetail}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <BusinessLocationInfo
                locationData={locationData}
                fetchBusinessDetail={this.fetchBusinessDetail}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <BusinessPlanInfo
                businessName={name}
                planSubscription={planSubscription}
                fetchBusinessDetail={this.fetchBusinessDetail}
                plans={plans}
                billingAddresses={billing_addresses}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default withRouter(BusinessDetail);



// WEBPACK FOOTER //
// ./src/containers/BusinessDetail.js